export default {
  main: "Points",
  
  navigation: {
    view_history: "View History",
    back_to_users: "Back to Users List"
  },
  
  list: {
    headers: {
      id: "ID",
      name: "Name",
      email: "Email"
    },
    actions: {
      add_points: "Add Points",
      view_history: "View User Points History"
    }
  },
  
  search: {
    title: "User Search",
    user: "Search for user",
    placeholder: "Enter name, surname or email",
    results: "Search Results",
    no_results: "No users found matching your search criteria",
    instructions: "Search for users above to award points",
    error: "Error occurred while searching for users"
  },
  
  filters: {
    date_range: "Date Range",
    point_type: "Point Type",
    type_manual: "Manual",
    type_auto_prework: "Pre-work",
    type_auto_quiz: "Quiz",
    type_auto_task: "Task",
    type_auto_reflection: "Reflection",
    last_week: "Last 7 days",
    last_month: "Last 30 days",
    last_quarter: "Last quarter",
    last_3_months: "Last 90 days",
    last_year: "Last year"
  },
  
  history: {
    title: "Points History",
    no_history: "No points history available",
    error: "Error occurred while fetching points history",
    headers: {
      user: "User",
      date: "Date & Time",
      points: "Points",
      reason: "Reason",
      awarded_by: "Awarded By"
    }
  },
  
  modal: {
    add_points: {
      title: "Add Points",
      user_label: "User",
      email_label: "Email",
      points_number: "Number of Points",
      reason_label: "Reason",
      program_label: "Program",
      reason_placeholder: "Enter reason for awarding points",
      save_button: "Save",
      cancel_button: "Cancel",
      errors: {
        invalid_points: "Please enter a positive whole number",
        empty_reason: "Please provide a reason for awarding points",
        no_program_selected: "Please select a program"
      }
    }
  },
  
  notifications: {
    award_success: "Points awarded successfully",
    award_error: "Error occurred while awarding points",
    fetch_error: "Failed to load points data"
  },
  
  status: {
    no_users: "No users available",
    users_error: "Error occurred while loading users"
  }
}; 